import TwoSection, {
    TwoSectionSubTitle, TwoSectionText,
    TwoSectionTitle,
} from "@/Components/TwoSection";
import { Link } from "@inertiajs/inertia-react";
import React from "react";
import AboutSection from "@/Pages/AboutUs/AboutSection";


const AboutSectionContent = () => {
    return (
        <AboutSection>

        </AboutSection>
    );
};

export default AboutSectionContent;
